/**
 * How a linked clone names the version it runs (#1260): the owner's task and the owner's version, as in
 * "Zero Human's eng-implement-issue, version 7", so the same number means the same task text in every enterprise.
 * With no owner name to give, the task name and version stand alone rather than behind a placeholder.
 */
export function ownerVersionLabel(ownerName: string | null | undefined, taskName: string, version: number): string {
    return ownerName ? `${ownerName}'s ${taskName}, version ${version}` : `${taskName}, version ${version}`
}

/**
 * Which owner version a clone is on and which it could move to, as "on 7, 8 available"; just "on 7" once nothing
 * newer is available.
 */
export function cloneOnLabel(version: number, availableVersion: number | null | undefined): string {
    return availableVersion == null ? `on ${version}` : `on ${version}, ${availableVersion} available`
}

/**
 * The owner's version a catalog entry's version stands for: the one it was published from, or its own number for an
 * entry version from before publication was recorded. Null when the API sent no version number.
 */
export function entryOwnerVersion(
    version: { version?: number; sourceVersion?: number | null } | null | undefined,
): number | null {
    return version?.sourceVersion ?? version?.version ?? null
}
